<template>  
  <div v-if="section_warhead_visible">
    <span class="title">Click one or more warheads to see available {{ SecTitle }}: </span>
    <button class="selectAll" type="button" v-on:click="check_all_thing"> Select All </button>  
    <div id="instance_warhead" class="cardList" >
      <warheadCard v-on:click_checkbox = "click_checkbox"
        v-for               = "(card, index) in warheadData"
        v-bind:key          = "index"
        v-bind:imgUrl       = "card.url"
        v-bind:warheadName  = "card.name"
        v-bind:count        = "card.count" 
        v-bind:checked      = "card.checked" /> 
    </div>  
    <hr /> 
  </div>  
</template>  

<script>  
import warheadCard from './warheadCard.vue'; 

export default {
  name: 'warheadSection', 
  props: ['SecTitle', 'warheadData', 'section_warhead_visible'], 
  methods: { 
    click_checkbox: function (cardName) { 
      this.$emit('click_checkbox', cardName);
    },
    check_all_thing: function () {
      this.$emit('check_all_thing', 'checkbox_warhead'); 
    }
  },  
  components: {
    warheadCard
  }, 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>  
  .cardList {
    display: flex;
    flex-direction: row; 
    flex-wrap: wrap;
  } 
  .selectAll {
    font-size: 1.5em;
    font-weight: bold;
  }
  .title {
    font-size: 2em;
    font-weight: bold;
  }
</style>
